module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"activities":{"read":"Les","memorize":"Memo","quiz":"Quiz","memorize2":"Memo","quiz2":"Quiz"}},"en":{"activities":{"read":"Read","memorize":"Memo","quiz":"Quiz","memorize2":"Memo","quiz2":"Quiz"}}}')
  delete Component.options._Ctor
}
